<template>
  <div id="func-11">
    <div style="padding: 0px 0 0 10px;">
      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">{{ textoVinculoContrato }}</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.idContrato }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Nome do {{ textoVinculoContrato.toLowerCase() }}</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.descricaoContrato }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Número da guia</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.numeroGuia }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Tipo de Serviço</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.descricaoTipoServico }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Descriçao do <br/>procedimento</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.descricaoProcedimento }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Código do <br/>procedimento</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.codigoProcedimento }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Prestador</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.nomeExecutante }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6" class="label">
          <p>Local</p>
        </el-col>
        <el-col :span="18" class="valor">
          <p>{{ procedimento.localAtendimento }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6" class="label">
          <p>Data</p>
        </el-col>
        <el-col :span="18" class="valor">
          <p v-html="parseDate(procedimento.dataAtendimento)"></p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Beneficiário</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.nomeBeneficiario }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6">
          <p class="label">Tipo de beneficiário</p>
        </el-col>
        <el-col :span="18">
          <p class="valor">{{ procedimento.tipoUsuario }}</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6" class="label">
          <p>Quantidade</p>
        </el-col>
        <el-col :span="18" class="valor">
          <p>{{ procedimento.quantidade }} unidade(s)</p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item" v-if="funcParametros.visualizarValorPorItemServico">
        <el-col :span="6" class="label">
          <p>Valor do Serviço</p>
        </el-col>
        <el-col :span="18" class="valor">
          <p v-html="parseValor(procedimento.valorServico)"></p>
        </el-col>
      </el-row>

      <el-row class="func-11-detail-item">
        <el-col :span="6" class="label">
          <p>Valor da coparticipação</p>
        </el-col>
        <el-col :span="18" class="valor">
          <p v-html="parseValor(procedimento.valorCoparticipacao)"></p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'Func11DetalheServico',
  props: ['procedimento', 'funcParametros'],
  components: {},
  computed: {
    ...mapGetters('SetupApp', ['textoVinculoContrato', 'textoVinculoContrato'])
  },
  data () {
    return {}
  },
  methods: {
    parseValor: function (valor) {
      return `R$ ${Math.floor(valor)},<span>${(valor - Math.floor(valor)).toFixed(2).split('.')[1]}</span>`
    },
    parseDate: function (value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  },
  created () {
  }
}
</script>
